import styled from 'styled-components';

export const TeamTableWrapper = styled.div`
  overflow-x: auto;
`;

export const TeamTableContainer = styled.div`
  min-width: 767px;
`;
